import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AccessControlController } from '@shared/src/controllers/accesscontrol/accesscontrol.controller';
import { FileUpDownloadController } from '@shared/src/controllers/fileupdownload/fileupdownload.controller';
import { AccessControlBookColumnsDto } from '@shared/src/dtos/accesscontrol/book/AccessControlBookColumnsDto';
import { FilterAccessControlListsDto } from '@shared/src/dtos/accesscontrol/filter/FilterAccessControlListsDto';

@Component({
   selector: 'shared-accesscontrol-book-aside',
   templateUrl: './shared.accesscontrol.book.aside.component.html',
   styleUrls: ['./shared.accesscontrol.book.aside.component.scss']
})
export class SharedAccessControlBookAside {

   constructor(protected accessControlController: AccessControlController, protected translateService: TranslateService) { }


   public _filter: FilterAccessControlListsDto;
   @Input()
   set filter(value: FilterAccessControlListsDto) {
      if (value) {
         this._filter = value;

         this.accessControlController.getExcelColumns().subscribe(data => {
            this.items = data.columns;
            this.filteredItems = [...this.items];
            this._filter.accessControlBookColumnsDto = data;

            const columnsDto = Object.assign(new AccessControlBookColumnsDto(), this._filter.accessControlBookColumnsDto);

            this.checkedItems = this.items.map(item => {
               const propertyName = item.split('.').pop()?.toLowerCase() ?? '';
               const normalizedKey = columnsDto?.normalizeColumnName?.(propertyName);

               if (normalizedKey && typeof columnsDto[normalizedKey] === 'boolean') {
                  return columnsDto[normalizedKey] as boolean;
               }

               return false;
            });

            this.recalculateCheckboxKeys();

         });
      }
   }

   searchText: string = '';
   filteredItems: string[] = [];

   items: string[] = [];

   checkedItems: boolean[] = [];

   @Output()
   public closeAside: EventEmitter<any> = new EventEmitter();

   // Filtra los items cada vez que cambia searchText
   ngOnChanges() {
      this.filterItems();
   }

   filterItems() {
      const search = this.searchText?.trim().toLowerCase() || '';

      if (!search && this.items) {
         this.filteredItems = [...this.items];
      } else {
         this.filteredItems = this.items.filter(item =>
            this.translateService.instant(item).toLowerCase().includes(search)
         );
      }
   }

   onSearchChange() {
      this.filterItems();
   }

   booleanChanged() {
      this.recalculateCheckboxKeys();
   }

   // Devuelve una lista con la última palabra de los keys seleccionados
   getCheckboxKeys(): string[] {
      const seleccionadas = this.items
         .filter((_, i) => this.checkedItems[i])
         .map(key => key.substring(key.lastIndexOf('.') + 1));
      return seleccionadas;
   }

   // Devuelve true si todas las líneas están seleccionadas
   areAllFilteredSelected(): boolean {
      return this.filteredItems.every(item => this.checkedItems[this.items.indexOf(item)]);
   }

   hasSelectedItems(): boolean {
      return this.checkedItems.some(checked => checked);
   }


   // Marca o desmarca todas las líneas
   toggleSelection(): void {
      const shouldSelectAll = !this.areAllFilteredSelected();
      this.filteredItems.forEach(item => {
         this.checkedItems[this.items.indexOf(item)] = shouldSelectAll;
      });

      this.recalculateCheckboxKeys();
   }


   recalculateCheckboxKeys(): void {
      if (this._filter)
         this._filter.columnsExportList = this.getCheckboxKeys();
   }


}
